import { Create } from 'react-admin';
import { GoodsForm } from './Goods.Form';

export const GoodsCreate = () => {
    return (
        <Create redirect="list">
            <GoodsForm />
        </Create>
    );
};
